import React from 'react';
import Layout from '../../layout';
import BookstoreLayout from '../bookstore-layout';

const OwnersLiteratureLayout: React.FC = ({ children }) => (
  <Layout title="Owner's Literature">
    <BookstoreLayout
      title="Owner's Literature"
      subtitle="Welcome to the Owner's Literature page of this website. Use this page to order specific owner's literature, such as the owner's manual, warranty materials, and other glove box items for the model and year of the Volvo vehicle you specify. Choose your model from the dropdown below, then you can refine your search by model year and/or manual type. Please note that for Owner's Manuals and Complete Wallets, there may be multiple versions depending on the production date of your vehicle."
      breadcrumb={{ url: '/owners', text: 'Back' }}
      hero=""
    >
      {children}
    </BookstoreLayout>
  </Layout>
);

export default OwnersLiteratureLayout;
